import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const HighChartContainer = ({ options }) => (
  <HighchartsReact highcharts={Highcharts} options={options} />
);

export default HighChartContainer;
